export type InnovatricsDocumentType = {
  name: string;
  type: string;
};

export const InnovatricsDocumentTypes: InnovatricsDocumentType[] = [
  { name: 'Birth Certificate', type: 'BIRTH_CERTIFICATE' },
  { name: 'Foreigner Permanent Residence', type: 'FOREIGNER_PERMANENT_RESIDENCE' },
  { name: 'Foreigner Residence', type: 'FOREIGNER_RESIDENCE' },
  { name: 'Foreigner Temporary Residence', type: 'FOREIGNER_TEMPORARY_RESIDENCE' },
  { name: 'Identity Card', type: 'IDENTITY_CARD' },
  { name: 'Insurance Card', type: 'INSURANCE_CARD' },
  { name: 'Long Term Pass', type: 'LONG_TERM_PASS' },
  { name: 'Passport', type: 'PASSPORT' },
  { name: 'Postal ID', type: 'POSTAL_ID' },
  { name: 'Profession Card', type: 'PROFESSION_CARD' },
  { name: 'Social Security', type: 'SOCIAL_SECURITY' },
  { name: 'Voter Registration', type: 'VOTER_REGISTRATION' },
  { name: 'Work Pass', type: 'WORK_PASS' },
  { name: 'Work Permit', type: 'WORK_PERMIT' },
];
